import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TypeReleveCompteur } from 'src/api/models';

@Component({
  selector: 'app-releve-compteur-type-select',
  templateUrl: './releve-compteur-type-select.component.html',
  styleUrls: ['./releve-compteur-type-select.component.css']
})
export class ReleveCompteurTypeSelectComponent implements OnInit {

  @Input('id') public id: number;
  @Output() idChange = new EventEmitter<number>();

  @Input('width') width: number;

  @Input() cell: any;

  typeReleveCompteur = [];

  constructor(private translateService: TranslateService) {     
    for (var t in TypeReleveCompteur) {
      let value = parseInt(t, 10);
      var isValueProperty = (value >= 0);
      if (isValueProperty) {
        this.typeReleveCompteur.push({ id: value, name: this.translateService.instant('Entretien.RelevesCompteurs.TypesCompteurs.' + TypeReleveCompteur[t])});
      }
    }    
  }

  ngOnInit(): void {
  }

  valueChanged(e) {
    if (!!this.cell) {
      this.cell.setValue(this.id);
    }    

    this.idChange.emit(this.id);
  }   

}
